import React from "react";
import { useSpeechSynthesis } from "react-speech-kit";

const PlayAudio = (props) => {
    // const [value, setValue] = React.useState("");
    const {text} = props;
    const { speak, cancel } = useSpeechSynthesis();

    const onPlayClick = () => {
        cancel();
        speak({ text: text })
    }
    return (
        <>
            <i style={{ fontSize: '10px', cursor: 'pointer' }} className="fa fa-caret-square-o-right"
                onClick={() => onPlayClick()} title="Play News"></i>
            &nbsp;
            <i style={{ fontSize: '10px', cursor: 'pointer' }} className="fa fa-pause" 
                onClick={() => cancel()} title="Cancel Audio"></i>
        </>
    )
};
export default PlayAudio;